import { render } from "./SecondBicom.vue?vue&type=template&id=688dbb70&scoped=true"
import script from "./SecondBicom.vue?vue&type=script&lang=js"
export * from "./SecondBicom.vue?vue&type=script&lang=js"

import "@/assets/styles/secondbicom.scss?vue&type=style&index=0&id=688dbb70&scoped=true&lang=scss"

import exportComponent from "/home/djokic/Projects/mariv/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-688dbb70"]])

export default __exports__